import { icons, type IconName } from './icons.js'

export const getIconByName = (name: IconName) => {
  const Icon = icons[name]
  if (!Icon) {
    throw new Error(`Icon "${name}" not found`)
  }
  return Icon
}
